import { currentUser } from '@utilities/functions';
import { applyPreferences } from '@utilities/bankAccountPreferences';

const getPrefs = function() {
    const settings = currentUser('settings') || {};
    return settings.bankAccountPreferences || {};
};

export default {
    data: function() {
        return {
            bankAccountPreferences: getPrefs(),
        };
    },

    methods: {
        onPreferencesSaved: function() {
            this.bankAccountPreferences = getPrefs();
        },

        filteredBankAccounts: function(accounts) {
            return applyPreferences(accounts, this.bankAccountPreferences);
        },
    },
};
